import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { BlockImage } from "../../../shared/components/BlockImage/BlockImage";
import type { IImageStandardProps } from "./ImageStandard.props";

export const ImageStandard = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageStandardProps) => (
  <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
    <div className="flex flex-col gap-10 md:gap-14">
      <BlockCommonContent
        alignment={alignment}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingLevel="h2"
      />
      {buttons?.length ? <BlockActions actions={buttons} alignment={alignment} /> : null}
      <BlockImage
        className="!max-w-none w-full"
        effectiveAspectRatio={image.aspectRatio ?? "unrestricted"}
        image={image}
      />
    </div>
  </BlockContainer>
);

ImageStandard.displayName = "Image::ImageStandard";
